// import 'antd/dist/antd.less';
// import './src/styles/theme.less';
import './src/styles/global.css';
import './src/styles/carousel.css';
import './src/styles/spinner.css';